module.exports = "/packs/media/images/meeting_2-098220b4a0d7042e956abdb789cacde3.jpg";